module.exports = __webpack_public_path__ + "media/Pyotr Ilyich Tchaikovsky - Dance of the Sugar Plum Fairy.0df3ae64.mp3";